export default "__VITE_ASSET__a9ab896a__"